import {makeAutoObservable} from 'mobx';

class ScreenResizeStore {
    public width = window.innerWidth;

    constructor() {
        makeAutoObservable(this);
        window.addEventListener('resize', this.handleResize);
    }

    public handleResize = (): void => {
        this.width = window.innerWidth;
    };
}

export const screenResizeStore = new ScreenResizeStore();
